module.exports = __webpack_public_path__ + "static/media/College_of_Liberal_Arts_International_Conferences.687b91b5.doc";